/**
 * @generated SignedSource<<23f0de59cf33ef8ff0629c218e201503>>
 * @relayHash 44d33734a57fe8c7f7a99327ed1b3bb6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8e7cb5c5d4b068992bf4e3a9165ddeb4b80a8a2a7069f0d32e866e7c37c7206e

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateDatabaseMutation$variables = {
  parentId?: string | null | undefined;
  spaceKey: string;
};
export type CreateDatabaseMutation$data = {
  readonly createContentContextual: {
    readonly id: string | null | undefined;
    readonly space: {
      readonly alias: string | null | undefined;
      readonly id: string | null | undefined;
      readonly key: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type CreateDatabaseMutation = {
  response: CreateDatabaseMutation$data;
  variables: CreateDatabaseMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "parentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "parentId",
            "variableName": "parentId"
          },
          {
            "kind": "Variable",
            "name": "spaceKey",
            "variableName": "spaceKey"
          },
          {
            "kind": "Literal",
            "name": "status",
            "value": "CURRENT"
          },
          {
            "kind": "Literal",
            "name": "type",
            "value": "database"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "createContentContextual",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "kind": "ScalarField",
            "name": "alias"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "CreateDatabaseMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateDatabaseMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "44d33734a57fe8c7f7a99327ed1b3bb6",
    "id": "8e7cb5c5d4b068992bf4e3a9165ddeb4b80a8a2a7069f0d32e866e7c37c7206e",
    "metadata": {},
    "name": "CreateDatabaseMutation",
    "operationKind": "mutation",
    "text": "mutation CreateDatabaseMutation($spaceKey:String!,$parentId:ID){createContentContextual(input:{parentId:$parentId,spaceKey:$spaceKey,status:CURRENT,type:\"database\"}){id,space{id,key,alias}}}"
  }
};
})();

(node as any).hash = "73166918266ac70a8951e44091e9370f";

export default node;
